
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_1jwh4_94",
  "outline": "awsui_outline_4yi2u_1jwh4_106",
  "toggle-control": "awsui_toggle-control_4yi2u_1jwh4_125",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_1jwh4_134",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_1jwh4_137",
  "toggle-handle": "awsui_toggle-handle_4yi2u_1jwh4_144",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_1jwh4_156",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_1jwh4_159"
};
  